/* import __COLOCATED_TEMPLATE__ from './admin-projects-application.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { APPLICATION_STATUS } from 'sh-www/models/application';

class AdminProjectsApplication extends Component {
  get statusText() {
    const { model } = this.args;

    switch (model.status) {
      case APPLICATION_STATUS.PUBLISHER_APPROVED:
      case APPLICATION_STATUS.PUBLISHER_APPROVED_PRICE:
        return 'Needs Seller Action';

      case APPLICATION_STATUS.PRODUCER_APPROVED:
        return 'Needs Buyer Action';

      default:
        return model.statusText;
    }
  }

  @action
  handleClick(e) {
    const { showProjectDigest, model } = this.args;

    e.preventDefault();
    e.stopPropagation();

    showProjectDigest(model.projectdigest);
  }

  @action
  copyLink(e) {
    const { copyProjectDigestLink, model } = this.args;

    e.preventDefault();
    e.stopPropagation();

    copyProjectDigestLink(model.projectdigest);
  }
}

export default AdminProjectsApplication;
